import { css } from "styled-components";

export const PaginatedTableStyles = css(({ theme }) => ({
    ".PaginatedTable": {
        "&& .TableFooter": {
            height: "auto",
            minHeight: "unset",
            justifyContent: "space-between",
            flexWrap: "wrap" as const,
            rowGap: theme.spacing[3],
        },
    },
}));
